import './section.css';
import PropTypes from 'prop-types';
import React from 'react'
import ReactDOM from 'react-dom'

const Section = ({children}) => {
    return (
        <section className='section'>
            <div className='container'>
                {children}
            </div>
        </section>
    );
}

export default Section;

Section.propTypes = {
    children: PropTypes.node.isRequired,
  };


// WEBPACK FOOTER //
// ./src/page/about-us/section/section.js